module.exports = __webpack_public_path__ + "static/media/shower-rain.310969c6.svg";